import axios from "axios";

export default {
  namespaced: true,
  state: {
    bills: [],
    images: [],
    query: {},
    isReceiving: false,
    isUpdating: false,
    isDeleting: false,
    idToDelete: null,
    billsMessage: ''
  },
  mutations: {
    SET_QUERY(state, payload) {
      state.query = Object.assign({}, payload);
    },
    CLEAR_BILLS(state) {
      state.bills = [];
    },
    FINDING_BILLS(state, payload) {
      state.isReceiving = true;
      state.query = Object.assign({}, payload);
    },
    RECEIVED_BILLS(state, payload) {
      state.bills = payload;
      state.isReceiving = false;
    },
    RECEIVED_BILL(state, payload) {
      let find = state.bills.find(i=>i._id==payload._id);
      state.isReceiving = false;
      if(find==null){
        state = Object.assign(state, { bills: [payload, ...state.bills] });
      }
      else {
        let index = state.bills.findIndex(x => x._id === payload._id);
        state.bills.splice(index, 1, payload);
      }
    },
    RECEIVING_BILLS(state) {
      state.isReceiving = true;
    },
    RECEIVING_TRANSACTIONS(state) {
      state.isReceiving = true;
    },
    RECEIVED_TRANSACTIONS(state) {
      state.isReceiving = false;
    },
    RECEIVING_BILL(state) {
      state.isReceiving = true;
    },
    UPDATED_BILL(state, payload) {
      let index = state.bills.findIndex(bill => bill._id === payload._id);
      state = Object.assign(state, {
        bills: state.bills.map((bill, i) => {
          if (i === index) {
            return Object.assign({}, bill, payload);
          }
          return bill;
        }),
        isUpdating: false,
        billsMessage: 'Bills has been updating!',
      })
    },
    UPDATING_BILL(state) {
      state.isUpdating = true;
    },
    DELETED_BILL(state, payload) {
      console.log(payload._id);
      let indexToDelete = state.bills.findIndex(bill => bill._id === payload._id);
      console.log(indexToDelete);
      let bills = [...state.bills];
      bills.splice(indexToDelete, 1);
      state = Object.assign(state, {
        bills: [...bills],
        isDeleting: false,
        idToDelete: null,
        billsMessage: 'Bill has been Deleted!',
      });
    },
    DELETE_ROLE_SUCCESS(state, payload) {
      let indexToDelete = state.roles.findIndex(role => role._id === payload._id);
      console.log(indexToDelete);
      let roles = [...state.roles];
      roles.splice(indexToDelete, 1);
      state = Object.assign(state, {
        roles: [...roles],
        isDeleting: false,
        idToDelete: null,
        rolesMessage: 'Role has been Deleted!',
      });
    },
    DELETING_BILL(state, payload) {
      state.isDeleting = true;
      state.idToDelete = payload.id;
    },
  },
  actions: {
    async deleteBillRequest({dispatch}, payload) {
      dispatch("deletingBill", payload);
      let token = localStorage.getItem('token')
      let url = 'https://api.tradexc.com:3000/delete/bill/' + payload._id;
      let headers = {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token};

      return axios({method: "delete", url: url, headers: headers})
      .then(response=>{
        dispatch("deleteBill", {_id: response.data._id});
      })
      .catch(error=>{
        console.log(error.data);
      });
    },
    async deleteBillTransactionRequest({dispatch}, payload) {
      try{
        dispatch("receivingTransactions");
        let token = localStorage.getItem("token");
        let url = "https://api.tradexc.com:3000/delete/billtransaction/" + payload._id;
        let headers = {"Content-Type": "application/json", Authorization: "Bearer " + token};
        let response = await axios({ method: "delete", url: url, headers: headers });
        dispatch("receiveTransactions");
        return response.data;
      }
      catch(e){return null}
    },
    async insertBillRequest({dispatch}, payload) {
      try {
        dispatch("receivingBills");
        var token = localStorage.getItem('token');
        let url = 'https://api.tradexc.com:3000/insert/bill';
        let data = payload;
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        console.log('here2');
        let response = await axios({method: "post", url: url, headers: headers, data: data});
        await dispatch("receiveBill", response.data);
        return response.data;
      } catch (error) {
        console.log(error.data);
      }

    },
    async insertBillTransactionRequest({dispatch}, payload) {
      try{
        dispatch("receivingTransactions");
        delete payload['branditems'];
        delete payload['_id'];
        let token = localStorage.getItem("token");
        let url = "https://api.tradexc.com:3000/insert/billtransaction/" + payload.billid;
        let headers = {"Content-Type": "application/json", Authorization: "Bearer " + token};
        let response = await axios({ method: "post", url: url, headers: headers, data: payload });
        dispatch("receiveTransactions");
        return response.data;
      }
      catch(e){console.log(e)}
    },
    async getBillsRequest({dispatch}) {
      dispatch("receivingBills");
      let token = localStorage.getItem('token');
      let url = 'https://api.tradexc.com:3000/get/bills';
      let header = {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token};
      return axios({method: "get", url: url, headers: header})
      .then(response => {
        console.log('bills', response.data)
        dispatch("receiveBills", response.data);
      })
    },
    async getBillRequest({dispatch}, id) {
      dispatch("receivingBills");
      let token = localStorage.getItem('token');
      let url = 'https://api.tradexc.com:3000/get/bill/' + id;
      let header = {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token};
      let response = await axios({method: "get",url: url,headers: header});
      dispatch("receiveBill", response.data);
      return response.data;
    },
    async findBillsRequest({dispatch}, payload) {
      try{
        dispatch("receivingBills", payload);
        dispatch("setQuery", payload);
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let url = 'https://api.tradexc.com:3000/find/bills';
        let response = await axios({method: "POST", url: url, headers: headers, data: payload});
        dispatch("receiveBills", response.data);
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async updateBillRequest({dispatch}, payload) {
      dispatch("updatingBill");
      let id = payload._id;
      delete payload['_id'];
      let token = localStorage.getItem('token');
      let url = 'https://api.tradexc.com:3000/update/bill/' + id;
      let headers = {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token};

      return axios({method: "put", url: url, headers: headers, data: payload})
      .then((response)=> {
        dispatch("updateBill", response.data);
      })
      .catch((error) => {
        this.alertmessage = error.response.data.error;
      });
    },
    async updateBillSendRequest({dispatch}, payload) {
      dispatch("updatingBill");
      var id = payload._id;
      delete payload['_id'];
      var token = localStorage.getItem('token');
      var url = 'https://api.tradexc.com:3000/update/bill/send/' + id;
      var header = {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token};

      let response = await axios({method:"put", url:url, headers:header, data:payload})
      dispatch("updatingBill", response.data);
      return response.data;
    },
    async updateBillTransaction({dispatch}, payload) {
      try{
        dispatch("receivingBill");
        let id = payload._id;
        delete payload['_id'];
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let url = 'https://api.tradexc.com:3000/update/billtransaction/' + id;
        let response = await axios({method: "PUT", url: url, headers: headers, data: payload});
        dispatch("receivingBill", response.data);
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    clearBills({commit}) {
      commit("CLEAR_BILLS")
    },
    async setQuery({commit}, payload) {
      commit("SET_QUERY", payload);
    },
    receiveBills({commit}, payload) {
      commit("RECEIVED_BILLS", payload)
    },
    receivingBills({commit}) {
      commit("RECEIVING_BILLS")
    },
    receivingTransactions({commit}) {
      commit("RECEIVING_TRANSACTIONS")
    },
    receiveTransactions({commit}) {
      commit("RECEIVED_TRANSACTIONS")
    },
    receiveBill({commit}, payload) {
      commit("RECEIVED_BILL", payload)
    },
    receivingBill({commit}) {
      commit("RECEIVING_BILL")
    },
    updateBill({commit}, payload) {
      commit("UPDATED_BILL", payload)
    },
    updatingBill({commit}) {
      commit("UPDATING_BILL")
    },
    deleteBill({commit}, payload) {
      commit("DELETED_BILL", payload)
    },
    deletingBill({commit}, payload) {
      commit("DELETING_BILL", payload)
    }
  },
};
